<template>
  <div class="container">
    <div class="column is-two-fifths">
      <notificationGroupsEdit
        :id="props.id"
        :can-edit-notification-group="canEditNotificationGroup"
        @group-update-complete="goBack"
        @cancel-update="goBack"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import notificationGroupsEdit from '@/components/notifications/notificationGroupsEdit.vue'
import { useAppStore } from '@/stores/app'
import routerUtils from '@/utils/routerUtils'

interface Props {
  id: number
  returnTo?: string
}

const props = withDefaults(defineProps<Props>(), {
  returnTo: '/notificationGroup/admin'
})

const appStore = useAppStore()

const canEditNotificationGroup = computed(() => {
  const selectedGroup = appStore.notificationGroups
    ? appStore.notificationGroups.find((x) => x.groupId === props.id)
    : undefined
  return selectedGroup?.canUpdateNotificationGroup ?? false
})

function goBack(): void {
  routerUtils.moveTo(props.returnTo)
}
</script>
